import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router';
import axios from 'axios';
import moment from 'moment';
import constClass from '../../Constants/Constants';
import { useToasts } from 'react-toast-notifications';
import imageCompression from "browser-image-compression";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ja from 'date-fns/locale/ja';
import Loading from '../Loading/Loading';
registerLocale('ja', ja);

const FirstBonus = (props) => {
  const { user } = props;
  const { siteId, mallId } = useParams();
  const [lockData, setLockData] = useState(false);
  const [masterData, setMasterData] = useState(null);
  const [searchData, setSearchData] = useState(null);
  const { addToast } = useToasts();
  const [winners, setWinners] = useState(null);

  const refreshMaster = useCallback(async () => {
    setLockData(true);
    var resdata = null
    try {
      const jwt = localStorage.getItem('jwt');
      resdata = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/firstbonus/backyard/${siteId}/${mallId}`, {
        headers: {
          Authorization: `Bearer ${jwt}`
        }
      })).data;

      resdata = {
        ...resdata,
        bonus_start: moment(resdata.bonus_start, 'YYYYMMDD').toDate(),
        bonus_end: moment(resdata.bonus_end, 'YYYYMMDD').toDate(),
        expire_date: moment(resdata.expire_date, 'YYYYMMDD').toDate(),
        uploadfile_message: resdata.message_image_url ? `/${siteId}/${resdata.message_image_url}` : null,
        uploadfile_banner: resdata.banner_image_url ? `/${siteId}/${resdata.banner_image_url}` : null,
      }
      console.log({ resdata })
    } catch (error) {
      resdata = null;
    }
    var data = {
      site_id: siteId,
      mall_id: mallId,
      bonus_start: resdata ? resdata.bonus_start : null,
      bonus_end: resdata ? resdata.bonus_end : null,
      point: resdata ? resdata.point : 0,
      expire_date: resdata ? resdata.expire_date : null,
      parsent: resdata ? resdata.parsent : null,
      limit_count: resdata ? resdata.limit_count : null,
      message_image_url: resdata ? resdata.message_image_url : null,
      banner_image_url: resdata ? resdata.banner_image_url : null,
      deletefile_message: null,
      uploadfiletype_message: null,
      uploadfile_message: resdata ? resdata.uploadfile_message : null,
      deletefile_banner: null,
      uploadfiletype_banner: null,
      uploadfile_banner: resdata ? resdata.uploadfile_banner : null,
      upd_date: resdata ? resdata.upd_date : null,
    }
    console.log(data)
    setMasterData(data);
    setLockData(false);
  }, [siteId, mallId]);

  const registerData = async () => {
    try {
      if (!masterData.bonus_start || !masterData.bonus_end || moment(masterData.bonus_start) > moment(masterData.bonus_end)) {
        window.alert('期間指定が間違っています。');
        return;
      }
      if (!masterData.expire_date) {
        window.alert('ポイント有効期限をご入力してください。');
        return;
      }
      var data = {
        ...masterData,
        bonus_start: moment(masterData.bonus_start).format('YYYYMMDD'),
        bonus_end: moment(masterData.bonus_end).format('YYYYMMDD'),
        point: Number(masterData.point),
        expire_date: moment(masterData.expire_date).format('YYYYMMDD'),
        parsent: Number(masterData.parsent),
        limit_count: Number(masterData.limit_count),
        upd_name: user.userId
      }
      if (isNaN(data.point) || data.point < 1) {
        window.alert('ポイントは数字で1以上をご入力ください。');
        return;
      }
      if (isNaN(data.parsent) || data.parsent < 1 || data.parsent > 100) {
        window.alert('当選確率は数字で1～100をご入力ください。');
        return;
      }
      if (isNaN(data.limit_count)) {
        window.alert('当選上限数は数字をご入力ください。（指定しない場合は0を入力）');
        return;
      }
      if (!window.confirm(`登録してよろしいですか？`)) {
        return;
      }
      setLockData(true);

      const jwt = localStorage.getItem('jwt');
      const res = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/firstbonus/backyard/${siteId}/${mallId}`, data, {
        headers: {
          Authorization: `Bearer ${jwt}`
        }
      }));
      if (res && res.data && res.data.result) {
        //正常終了
        addToast(`更新完了しました。`, { appearance: 'success', autoDismiss: true });
        refreshMaster();
      } else {
        console.log(res.data)
        //異常終了
        addToast((res && res.data && res.data.msg) ? res.data.msg : "エラーが発生しました", { appearance: 'error', autoDismiss: true });
      }
    } catch (error) {
      console.log(error, user)
    } finally {
      setLockData(false);
    }
  }

  useEffect(() => {
    refreshMaster();
  }, [refreshMaster]);

  const setDateValue = (value, name) => {
    console.log(value)
    setMasterData({ ...masterData, [name]: value });
  }
  const setSearchValue = (value, name) => {
    setSearchData({ ...searchData, [name]: value });
  }
  const handleChange = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? (target.checked ? constClass.FLAG.ON : constClass.FLAG.OFF) : target.value;
    const name = target.name;
    setMasterData({ ...masterData, [name]: value });
  }

  const handleChangeFileMessage = async (e) => {
    const value = e.target.files[0];

    const compressOption = {
      maxSizeMB: 10, // 最大ファイルサイズ
      maxWidth: 1040 // 最小画像幅もしくは高さ
    }
    const compressFile = await imageCompression(value, compressOption);
    const url = await imageCompression.getDataUrlFromFile(compressFile);
    var reader = new FileReader();
    reader.onloadend = () => {
      setMasterData({
        ...masterData,
        uploadfile_message: url,
        uploadfiletype_message: value.type,
        deletefile_message: masterData.message_image_url
      });
    }
    reader.readAsDataURL(value);
  }
  const handleChangeFileBanner = async (e) => {
    const value = e.target.files[0];

    const compressOption = {
      maxSizeMB: 1, // 最大ファイルサイズ
      maxWidthOrHeight: 1024 // 最大画像幅もしくは高さ
    }
    const compressFile = await imageCompression(value, compressOption);
    const url = await imageCompression.getDataUrlFromFile(compressFile);
    var reader = new FileReader();
    reader.onloadend = () => {
      setMasterData({
        ...masterData,
        uploadfile_banner: url,
        uploadfiletype_banner: value.type,
        deletefile_banner: masterData.banner_image_url
      });
    }
    reader.readAsDataURL(value);
  }
  const handleDeleteFile = (name) => {
    if (name === "deletefile_message") {
      setMasterData({ ...masterData, uploadfile_message: null, uploadfiletype_message: null, deletefile_message: masterData.message_image_url });
    } else {
      setMasterData({ ...masterData, uploadfile_banner: null, uploadfiletype_banner: null, deletefile_banner: masterData.banner_image_url });
    }
  }
  const search = async () => {
    setLockData(true);
    var resdata = null
    try {
      const jwt = localStorage.getItem('jwt');
      const params = {
        siteId: siteId,
        mallId: mallId,
        searchStart: searchData && searchData.search_start ? moment(searchData.search_start).format('YYYYMMDD') : null,
        searchEnd: searchData && searchData.search_end ? moment(searchData.search_end).format('YYYYMMDD') : null
      }
      resdata = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/firstbonus/backyard/winnerscheck`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`
        }
      })).data;
    } catch (error) {
      resdata = null;
    }
    setWinners(resdata || 0);
    setLockData(false);
  }

  return (
    <div className="container">
      <div className="row mx-0 my-2 px-1-env">
        <div className='col h4'>初回登録特典</div>
      </div>
      {masterData &&
        <div className="row mx-0 my-2 px-1-env">
          <div className="col-10">
            <div className="row my-3">
              <div className="col-3 pt-1 pr-0 pl-1 text-center align-self-center">
                <span>特典期間</span>
              </div>
              <div className="col-4 text-center">
                <DatePicker className="custom-select text-left"
                  locale="ja" dateFormat="yyyy/MM/dd" monthsShown="1" id={'bonus_start'} name={'bonus_start'}
                  popperPlacement='bottom'
                  selected={masterData && masterData.bonus_start ? masterData.bonus_start : null}
                  onChange={(value) => setDateValue(value, "bonus_start")}
                  placeholderText="- 選択 -"
                  autoComplete='off'
                  isClearable={true}
                  onFocus={(e) => e.target.blur()}
                />
              </div>
              <div className="col-1 text-center">～</div>
              <div className="col-4 text-center">
                <DatePicker className="custom-select text-left"
                  locale="ja" dateFormat="yyyy/MM/dd" monthsShown="1" id={'bonus_end'} name={'bonus_end'}
                  popperPlacement='bottom'
                  selected={masterData && masterData.bonus_end ? masterData.bonus_end : null}
                  onChange={(value) => setDateValue(value, "bonus_end")}
                  placeholderText="- 選択 -"
                  autoComplete='off'
                  isClearable={true}
                  onFocus={(e) => e.target.blur()}
                />
              </div>
            </div>
            <div className="row my-3">
              <div className="col-3 pt-1 pr-0 pl-1 text-center align-self-center">
                <span>特典ポイント</span>
              </div>
              <div className="col-4 pt-1 text-center">
                <input className={`form-control`} type="text" id={'point'} name={'point'} value={masterData.point || ""} onChange={handleChange} ></input>
              </div>
            </div>
            <div className="row my-3">
              <div className="col-3 pt-1 pr-0 pl-1 text-center align-self-center">
                <span>特典ポイント有効期限</span>
              </div>
              <div className="col-4 pt-1 text-center">
                <DatePicker className="custom-select text-left"
                  locale="ja" dateFormat="yyyy/MM/dd" monthsShown="1" id={'expire_date'} name={'expire_date'}
                  popperPlacement='bottom'
                  selected={masterData && masterData.expire_date ? masterData.expire_date : null}
                  onChange={(value) => setDateValue(value, "expire_date")}
                  placeholderText="- 選択 -"
                  autoComplete='off'
                  isClearable={true}
                  onFocus={(e) => e.target.blur()}
                />
              </div>
            </div>
            <div className="row my-3">
              <div className="col-3 pt-1 pr-0 pl-1 text-center align-self-center">
                <span>当選確率</span>
              </div>
              <div className="col-4 pt-1 text-center">
                <input className={`form-control`} type="text" id={'parsent'} name={'parsent'} value={masterData.parsent || ""} onChange={handleChange} ></input>
              </div>
              <div className="col-1 pt-1 text-center">
                ％
              </div>
            </div>
            <div className="row my-3">
              <div className="col-3 pt-1 pr-0 pl-1 text-center align-self-center">
                <span>当選上限数</span>
              </div>
              <div className="col-4 pt-1 text-center">
                <input className={`form-control`} type="text" id={'limit_count'} name={'limit_count'} value={masterData.limit_count || ""} onChange={handleChange} ></input>
              </div>
              <div className="col-1 pt-1 text-center">
                名
              </div>
            </div>
            <div className="row my-3">
              <div className="col-3 pt-1 pr-0 pl-1 text-center align-self-center">
                <span>通知メッセージ</span>
              </div>
              <div className="col-9 pt-1 text-left">
                <div>※画像サイズ：1040px　×　1040px</div>
                <div className='w-50'>
                  {!(masterData.uploadfile_message) && <input type="file" className="form-control-file" name="message_image_url" id="message_image_url" value="" onChange={handleChangeFileMessage} onClick={e => (e.target.value = null)} />}
                  {masterData.uploadfile_message && <object id="uploadfileview_message" className="w-100" data={masterData.uploadfile_message} type={masterData.uploadfiletype_message}><img className="w-100" src={masterData.uploadfile_message} alt='uploadfile_message' /></object>}
                  {masterData.uploadfile_message && <input type="button" className="form-controll" name="deletefile_message" id="deletefile_message" onClick={e => handleDeleteFile("deletefile_message")} value="ファイル削除" />}
                </div>
              </div>
            </div>
            <div className="row my-3">
              <div className="col-3 pt-1 pr-0 pl-1 text-center align-self-center">
                <span>バナー画像</span>
              </div>
              <div className="col-9 pt-1 text-left">
                <div className='w-50'>
                  {!(masterData.uploadfile_banner) && <input type="file" className="form-control-file" name="bunner_image_url" id="bunner_image_url" value="" onChange={handleChangeFileBanner} onClick={e => (e.target.value = null)} />}
                  {masterData.uploadfile_banner && <object id="uploadfileview_banner" className="w-100" data={masterData.uploadfile_banner} type={masterData.uploadfiletype_banner}><img className="w-100" src={masterData.uploadfile_banner} alt='uploadfile_banner' /></object>}
                  {masterData.uploadfile_banner && <input type="button" className="form-controll" name="deletefile_banner" id="deletefile_banner" onClick={e => handleDeleteFile("deletefile_banner")} value="ファイル削除" />}
                </div>
              </div>
            </div>
            <div className="row my-3">
              <div className="col-4"></div>
              <div className="col-2 text-center align-bottom">
                <button type="button"
                  className={`btn btn-primary mx-1 w-100`}
                  disabled={lockData}
                  onClick={() => registerData()}>
                  登録</button>
              </div>
              <div className="col-2 text-center align-bottom">
                <button type="button"
                  className={`btn btn-primary mx-1 w-100`}
                  disabled={lockData}
                  onClick={() => refreshMaster()}>
                  リセット</button>
              </div>
              <div className="col-4"></div>
            </div>
          </div>
        </div>}
      <div className="row mx-0 my-2 px-1-env mt-4">
        <div className='col-10 row'>
          <div className='col-3 h4'>当選数の確認</div>
          {winners !== null && (
            <div className='col-8 h4'>{winners}人</div>
          )}
        </div>
      </div>
      <div className="row mx-0 my-2 px-1-env">
        <div className="col-10">
          <div className="row my-3">
            <div className="col-3 pt-1 pr-0 pl-1 text-center align-self-center">
              <span>検索期間</span>
            </div>
            <div className="col-4 text-center">
              <DatePicker className="custom-select text-left"
                locale="ja" dateFormat="yyyy/MM/dd" monthsShown="1" id={'search_start'} name={'search_start'}
                popperPlacement='bottom'
                selected={searchData && searchData.search_start ? searchData.search_start : null}
                onChange={(value) => setSearchValue(value, "search_start")}
                placeholderText="- 選択 -"
                autoComplete='off'
                isClearable={true}
                onFocus={(e) => e.target.blur()}
              />
            </div>
            <div className="col-1 text-center">～</div>
            <div className="col-4 text-center">
              <DatePicker className="custom-select text-left"
                locale="ja" dateFormat="yyyy/MM/dd" monthsShown="1" id={'search_end'} name={'search_end'}
                popperPlacement='bottom'
                selected={searchData && searchData.search_end ? searchData.search_end : null}
                onChange={(value) => setSearchValue(value, "search_end")}
                placeholderText="- 選択 -"
                autoComplete='off'
                isClearable={true}
                onFocus={(e) => e.target.blur()}
              />
            </div>
          </div>
        </div>
        <div className="col-10 d-flex justify-content-center">
          <div className="row col-2 my-3">
            <button type="button"
              className={`btn btn-primary mx-1 w-100 text-nowrap`}
              disabled={lockData}
              onClick={() => search()}>
              検索</button>
          </div>
        </div>
      </div>
      {(lockData || !masterData) && <Loading />}
    </div>
  )
}

export default FirstBonus;